import { Component, OnInit } from '@angular/core';

export interface FacultyMember {
  name: string;
  designation: string;
  phone: string;
  qualification: string;
  department: string;
  workingSince: string;
  image?: string;
  academicAchievements: {
    booksPublished: string;
    researchPapers: string;
    conferences: string;
  };
}

@Component({
  selector: 'app-teaching-staff',
  templateUrl: './teaching.component.html',
  styleUrls: ['./teaching.component.scss']
})
export class TeachingStaffComponent implements OnInit {
  staffList: FacultyMember[] = [
    {
      name: "Dr. Geeta Monga",
      designation: "Principal",
      phone: "9416413336",
      qualification: "MA (English), M.Phil (Gold Medalist), PHD (English)",
      department: "English",
      workingSince: "1997",
      image: "/assets/img/message/principal.jpg",
      academicAchievements: {
        booksPublished: "",
        researchPapers: "",
        conferences: ""
      }
    },
    {
      name: "Dr. Rishu Tomar",
      designation: "Associate Professor",
      phone: "8607225777",
      qualification: "M.A. (Geo.), B.Ed, Ph.D.",
      department: "Geography",
      workingSince: "10th January, 1997",
      image: "assets/img/faculty/teaching/rishu.png",
      academicAchievements: {
        booksPublished: "1 Book, 1 Chapter published",
        researchPapers: "10 papers published/presented",
        conferences: "2 conferences, 2 workshops, 3 seminars attended"
      }
    },

    /*
    {
      name: "Ms. Kiran Bala",
      designation: "Assistant Professor",
      phone: "9996092170",
      qualification: "M.A PUB. Adm., M.Phil, B.Ed",
      department: "Public Administration",
      workingSince: "8th January, 1997",
      image: "assets/img/faculty/teaching/Kiran.png",
      academicAchievements: {
        booksPublished: "",
        researchPapers: "",
        conferences: ""
      }
    },
    */

    {
      name: "Ms. Monika",
      designation: "Assistant Professor",
      phone: "9466471013",
      qualification: "M.A , B.ED, M.Phil ph.d pursuing",
      department: "English",
      workingSince: "15th July, 2000",
      image: "assets/img/faculty/teaching/monika.png",
      academicAchievements: {
        booksPublished: "",
        researchPapers: "8 published, 4 presented",
        conferences: "4 conferences attended"
      }
    },

    {
      name: "Ms. Poonam Dhamija",
      designation: "Assistant Professor",
      phone: "9991872781",
      qualification: "MA.B.Ed,M.Phil,SLET",
      department: "Hindi",
      workingSince: "15th July, 2000",
      image: "assets/img/faculty/teaching/poonam.png",
      academicAchievements: {
        booksPublished: "",
        researchPapers: "",
        conferences: ""
      }
    },

    /*
    {
      name: "Ms. Naresh Rani",
      designation: "Assistant Professor",
      phone: "7988154630",
      qualification: "M.A in phy.edu.certificate course in athletic(nis)M.A in punjabi Mphil in punjabi",
      department: "Physical Education",
      workingSince: "1st August, 1997",
      image: "assets/img/faculty/teaching/naresh.png",
      academicAchievements: {
        booksPublished: "",
        researchPapers: "",
        conferences: ""
      }
    },
    */

    {
      name: "Ms Pooja Taneja",
      designation: "Assistant Professor",
      phone: "9671860604",
      qualification: "MSc maths,B.Ed",
      department: "Mathematics",
      workingSince: "1st August, 2014",
      image: "assets/img/faculty/teaching/pooja-Taneja.png",
      academicAchievements: {
        booksPublished: "",
        researchPapers: "",
        conferences: ""
      }
    },

    {
      name: "Ms. Raman",
      designation: "Assistant Professor",
      phone: "7056835882",
      qualification: "M.P.Ed,B.Ed,MA in Hindi",
      department: "Physical Education",
      workingSince: "12th January, 2007",
      image: "assets/img/faculty/teaching/raman.png",
      academicAchievements: {
        booksPublished: "",
        researchPapers: "",
        conferences: ""
      }
    },

    /*
    {
      name: "Ms. Leenu Saneja",
      designation: "Assistant Professor",
      phone: "9728412215",
      qualification: "MBA,M.Com",
      department: "Commerce and Management",
      workingSince: "31st July, 2009",
      image: "assets/img/faculty/teaching/leenu.png",
      academicAchievements: {
        booksPublished: "",
        researchPapers: "",
        conferences: ""
      }
    },
    */

    {
      name: "Dr. Kanta",
      designation: "Assistant Professor",
      phone: "9916110070",
      qualification: "M.A. PUB AD., M. PHIL. PH.D.",
      department: "Public Administration",
      workingSince: "14th September, 2009",
      image: "assets/img/faculty/teaching/kanta-rani-img.png",
      academicAchievements: {
        booksPublished: "",
        researchPapers: "",
        conferences: ""
      }
    },

    {
      name: "Dr. Pooja Monga",
      designation: "Assistant Professor",
      phone: "7888438082",
      qualification: "MA in Eco.,M.com,MBA in HRM,B.Ed,M.Ed,M.Phil in Eco,Ph.D in Eco",
      department: "Economics",
      workingSince: "11th September, 2009",
      image: "assets/img/faculty/teaching/pooja-Monga.png",
      academicAchievements: {
        booksPublished: "5 chapters/books published",
        researchPapers: "16 published & 31 presented research papers",
        conferences: ""
      }
    },

    /*
    {
      name: "Ms. Neha",
      designation: "Assistant Professor",
      phone: "8708940166",
      qualification: "MBA,M.Com",
      department: "Commerce and Management",
      workingSince: "17th July, 2010",
      image: "assets/img/faculty/teaching/neha.png",
      academicAchievements: {
        booksPublished: "",
        researchPapers: "",
        conferences: ""
      }
    },
    */

    {
      name: "Ms. Ruby",
      designation: "Assistant Professor",
      phone: "7027343076",
      qualification: "MA, B.Ed",
      department: "Geography",
      workingSince: "7th January, 2011",
      image: "assets/img/faculty/teaching/ruby.png",
      academicAchievements: {
        booksPublished: "",
        researchPapers: "",
        conferences: ""
      }
    },

    {
      name: "Ms. Nisha phutela",
      designation: "Assistant Professor",
      phone: "8607391174",
      qualification: "MCA,M tech,B.Ed",
      department: "Computer Science",
      workingSince: "9th August, 2011",
      image: "assets/img/faculty/teaching/nisha.png",
      academicAchievements: {
        booksPublished: "",
        researchPapers: "1 paper published/presented",
        conferences: ""
      }
    },

    {
      name: "Ms. Rekha Mehta",
      designation: "Assistant Professor",
      phone: "9991566696",
      qualification: "M. Sc Physics, B.Ed ,Pursuing Ph.. D",
      department: "Physics",
      workingSince: "8th January, 2013",
      image: "assets/img/faculty/teaching/rekha.png",
      academicAchievements: {
        booksPublished: "",
        researchPapers: "4 published, 5 presented",
        conferences: "4 conferences attended"
      }
    },

    {
      name: "Ms. Madhu Bala",
      designation: "Assistant Professor",
      phone: "9467626669",
      qualification: "M.Sc maths, B.Ed",
      department: "Mathematics",
      workingSince: "9th September, 2013",
      image: "assets/img/faculty/teaching/madhu.png",
      academicAchievements: {
        booksPublished: "",
        researchPapers: "",
        conferences: ""
      }
    },

    {
      name: "MS. Renu Dara",
      designation: "Assistant Professor",
      phone: "9729400094",
      qualification: "M.M.C, M. Phil, B.ED, M.A Edu.",
      department: "Mass Communication",
      workingSince: "16th January, 2014",
      image: "assets/img/faculty/teaching/Renu-Dara.png",
      academicAchievements: {
        booksPublished: "",
        researchPapers: "",
        conferences: ""
      }
    },

    {
      name: "Ms. Suman rani",
      designation: "Assistant Professor",
      phone: "9254569781",
      qualification: "M.A Psychology , UGC Net",
      department: "Psychology",
      workingSince: "2nd January, 2014",
      image: "assets/img/faculty/teaching/suman-psychology.png",
      academicAchievements: {
        booksPublished: "",
        researchPapers: "",
        conferences: ""
      }
    },

    {
      name: "Ms. Avnee",
      designation: "Assistant Professor",
      phone: "9996851991",
      qualification: "B.sc Non Med M.Sc Maths",
      department: "Mathematics",
      workingSince: "8th January, 2014",
      image: "assets/img/faculty/teaching/Avnee.png",
      academicAchievements: {
        booksPublished: "",
        researchPapers: "",
        conferences: ""
      }
    },

    {
      name: "Ms. Payal rani",
      designation: "Assistant Professor",
      phone: "9992621112",
      qualification: "M.Sc in Chemistry,B.Ed",
      department: "Chemistry",
      workingSince: "8th January, 2014",
      image: "assets/img/faculty/teaching/payal.png",
      academicAchievements: {
        booksPublished: "",
        researchPapers: "",
        conferences: ""
      }
    },

    {
      name: "Ms. Ripna",
      designation: "Assistant Professor",
      phone: "8684979220",
      qualification: "M.Com,UGC Net",
      department: "Commerce",
      workingSince: "1st November, 2016",
      image: "assets/img/faculty/teaching/Ripna.png",
      academicAchievements: {
        booksPublished: "",
        researchPapers: "3 published, 1 presented",
        conferences: ""
      }
    },

    {
      name: "Dr. Divya",
      designation: "Assistant Professor",
      phone: "8295112687",
      qualification: "Ph.D, MCA,BCA",
      department: "Computer Science",
      workingSince: "8th January, 2015",
      image: "assets/img/faculty/teaching/Divya-img-2.png",
      academicAchievements: {
        booksPublished: "",
        researchPapers: "",
        conferences: ""
      }
    },

    {
      name: "Ms. Gurdeep Kaur",
      designation: "Assistant Professor",
      phone: "9896170899",
      qualification: "M.A English",
      department: "English",
      workingSince: "20th August, 2014",
      image: "assets/img/faculty/teaching/Gurdeep.png",
      academicAchievements: {
        booksPublished: "",
        researchPapers: "",
        conferences: ""
      }
    },

    {
      name: "Ms.Yogita",
      designation: "Assistant Professor",
      phone: "9996494419",
      qualification: "M.Com,MBA,B.Ed",
      department: "Commerce and Management",
      workingSince: "20th February, 2013",
      image: "assets/img/faculty/teaching/Yogita.png",
      academicAchievements: {
        booksPublished: "",
        researchPapers: "2 presented",
        conferences: ""
      }
    },

    {
      name: "Ms.Muskan Bajaj",
      designation: "Assistant Professor",
      phone: "9068254194",
      qualification: "MA English",
      department: "English",
      workingSince: "19th August, 2016",
      image: "assets/img/faculty/teaching/Muskan.png",
      academicAchievements: {
        booksPublished: "",
        researchPapers: "",
        conferences: ""
      }
    },

    {
      name: "Ms.Tajinder kaur",
      designation: "Assistant Professor",
      phone: "9017739684",
      qualification: "MA punjabi M.Ed,M.Sc(CS)Gyani,HTET",
      department: "Punjabi",
      workingSince: "8th August, 2017",
      image: "assets/img/faculty/teaching/Tajinder.png",
      academicAchievements: {
        booksPublished: "",
        researchPapers: "",
        conferences: ""
      }
    },

    {
      name: "Ms.Shalu",
      designation: "Assistant Professor",
      phone: "9896177210",
      qualification: "MA,B.Ed",
      department: "Hindi",
      workingSince: "11th December, 2020",
      image: "assets/img/faculty/teaching/Shalu.png",
      academicAchievements: {
        booksPublished: "",
        researchPapers: "",
        conferences: ""
      }
    },

    {
      name: "Ms.Dheeraj Pal kaur",
      designation: "Assistant Professor",
      phone: "9729675313",
      qualification: "M.A English, B.Ed",
      department: "English",
      workingSince: "11th December, 2020",
      image: "assets/img/faculty/teaching/Dheeraj-Pal.png",
      academicAchievements: {
        booksPublished: "",
        researchPapers: "",
        conferences: ""
      }
    },

    {
      name: "Ms Geeta Rani",
      designation: "Assistant Professor",
      phone: "9467091234",
      qualification: "MBA,M.Ed MA Pub Adm",
      department: "Public Administration",
      workingSince: "10th January, 2015",
      image: "assets/img/faculty/teaching/geeta.jpeg",
      academicAchievements: {
        booksPublished: "",
        researchPapers: "",
        conferences: ""
      }
    },

    {
      name: "Ms.Jasbir kaur",
      designation: "Assistant Professor",
      phone: "9896039150",
      qualification: "MA,B.Ed,M.Ed",
      department: "Public Administration",
      workingSince: "11th December, 2020",
      image: "assets/img/faculty/teaching/Jasbir.png",
      academicAchievements: {
        booksPublished: "",
        researchPapers: "",
        conferences: ""
      }
    },

    {
      name: "Ms. Suman",
      designation: "Assistant Professor",
      phone: "9817189990",
      qualification: "MA in Pub Adm,B.Ed",
      department: "Public Administration",
      workingSince: "1st October, 2021",
      image: "assets/img/faculty/teaching/Suman-Public-Administration.png",
      academicAchievements: {
        booksPublished: "",
        researchPapers: "",
        conferences: ""
      }
    },

    /*
    {
      name: "Ms. Sarita",
      designation: "Assistant Professor",
      phone: "8059003522",
      qualification: "M.COM.",
      department: "Commerce",
      workingSince: "19th August, 2016",
      image: "",
      academicAchievements: {
        booksPublished: "",
        researchPapers: "",
        conferences: ""
      }
    },
    */

    {
      name: "Ms. Kuldeep Kaur",
      designation: "Assistant Professor",
      phone: "8607798226",
      qualification: "B.Ed, Mcom",
      department: "Commerce",
      workingSince: "3rd March, 2022",
      image: "assets/img/faculty/teaching/kuldeep-kaur-img.png",
      academicAchievements: {
        booksPublished: "",
        researchPapers: "",
        conferences: ""
      }
    },

    {
      name: "Ms. Chanchal Rani",
      designation: "Associate Professor",
      phone: "9416806620",
      qualification: "M.Sc.(Maths),M.Phill,Ph.D.,NET Qualified",
      department: "Commerce and Management",
      workingSince: "1st August, 2021",
      image: "assets/img/faculty/teaching/chanchal.jpeg",
      academicAchievements: {
        booksPublished: "",
        researchPapers: "3 papers presented",
        conferences: ""
      }
    },

    /*
    {
      name: "Ms. Suman Rani",
      designation: "Assistant Professor",
      phone: "9466548123",
      qualification: "M.A. HINDI, M.ED.",
      department: "Hindi",
      workingSince: "20th December, 2021",
      image: "assets/img/faculty/teaching/Suman-Hindi.png",
      academicAchievements: {
        booksPublished: "",
        researchPapers: "",
        conferences: ""
      }
    },
    */

    {
      name: "Ms. Meena Rani",
      designation: "Assistant Professor",
      phone: "9315612456",
      qualification: "M.A. (Psy), B.Ed.",
      department: "Psychology",
      workingSince: "1st October, 2022",
      image: "assets/img/faculty/teaching/Meena.png",
      academicAchievements: {
        booksPublished: "",
        researchPapers: "",
        conferences: ""
      }
    },

    {
      name: "Ms. Anupama",
      designation: "Assistant Professor",
      phone: "7027772002",
      qualification: "M.A. (English), MMC",
      department: "Mass Communication",
      workingSince: "1st June, 2023",
      image: "",
      academicAchievements: {
        booksPublished: "",
        researchPapers: "",
        conferences: ""
      }
    },

    {
      name: "Ms. Rupa",
      designation: "Assistant Professor",
      phone: "7206571300",
      qualification: "B.Tech., M.Tech.",
      department: "Computer Science",
      workingSince: "6th October, 2023",
      image: "assets/img/faculty/teaching/Rupa.png",
      academicAchievements: {
        booksPublished: "",
        researchPapers: "1 paper published/presented",
        conferences: ""
      }
    },

    {
      name: "Ms. Priynka",
      designation: "Assistant Professor",
      phone: "9050884089",
      qualification: "BCA, MCA, M.Tech (persuing)",
      department: "Computer Science",
      workingSince: "1st April, 2023",
      image: "assets/img/faculty/teaching/Priynka.png",
      academicAchievements: {
        booksPublished: "",
        researchPapers: "",
        conferences: ""
      }
    },

    /*
    {
      name: "Ms. Veena Navjot",
      designation: "Assistant Professor",
      phone: "7494896638",
      qualification: "MCA",
      department: "Computer Science",
      workingSince: "18th September, 2023",
      image: "assets/img/faculty/teaching/Veena.png",
      academicAchievements: {
        booksPublished: "",
        researchPapers: "",
        conferences: ""
      }
    },
    */

    /*
    {
      name: "Ms. Neha Arora",
      designation: "Assistant Professor",
      phone: "9205620165",
      qualification: "B.Tech (CSE), M.Tech(IT)",
      department: "Computer Science",
      workingSince: "6th October, 2023",
      image: "assets/img/faculty/teaching/neha_arora.png",
      academicAchievements: {
        booksPublished: "",
        researchPapers: "1 paper published/presented",
        conferences: ""
      }
    },
    */

    {
      name: "Ms. Raman Rani",
      designation: "Assistant Professor",
      phone: "7027221010",
      qualification: "B.A., M.Sc.(Mathematics), B.Ed.",
      department: "Mathematics",
      workingSince: "17th February, 2024",
      image: "assets/img/faculty/teaching/Raman-Rani.png",
      academicAchievements: {
        booksPublished: "",
        researchPapers: "",
        conferences: ""
      }
    },

    {
      name: "Ms. Manjeet Kaur",
      designation: "Assistant Professor",
      phone: "8360825592",
      qualification: "BPED, MPED",
      department: "Physical Education",
      workingSince: "19th April, 2025",
      image: "",
      academicAchievements: {
        booksPublished: "",
        researchPapers: "",
        conferences: ""
      }
    },

    {
      name: "Ms. Vaishnavi Sharma",
      designation: "Assistant Professor",
      phone: "9306799915",
      qualification: "BPED, MPED",
      department: "Physical Education",
      workingSince: "10th December, 2025",
      image: "",
      academicAchievements: {
        booksPublished: "",
        researchPapers: "",
        conferences: ""
      }
    },

    {
      name: "Ms. Rajwanti",
      designation: "Assistant Professor",
      phone: "7082626003",
      qualification: "BPED, MPED",
      department: "Physical Education",
      workingSince: "12th February, 2026",
      image: "assets/img/faculty/teaching/rajwanti.jpeg",
      academicAchievements: {
        booksPublished: "",
        researchPapers: "",
        conferences: ""
      }
    },

    {
      name: "Ms. Shaina Rani",
      designation: "Assistant Professor",
      phone: "8168086749",
      qualification: "M.Sc. Psychology,NET Qualified",
      department: "Psychology",
      workingSince: "11th April, 2024",
      image: "assets/img/faculty/teaching/Shaina-Rani.png",
      academicAchievements: {
        booksPublished: "",
        researchPapers: "",
        conferences: ""
      }
    },

    {
      name: "Ms. Manish Kaswan",
      designation: "Assistant Professor",
      phone: "94666133388",
      qualification: "M.A. (English), BED",
      department: "English",
      workingSince: "2nd September, 2024",
      image: "",
      academicAchievements: {
        booksPublished: "",
        researchPapers: "",
        conferences: ""
      }
    },

    {
      name: "Dr. Nirja Rani",
      designation: "Assistant Professor",
      phone: "9729733771",
      qualification: "M.A. (English), Ph.D",
      department: "English",
      workingSince: "2nd September, 2024",
      image: "",
      academicAchievements: {
        booksPublished: "",
        researchPapers: "",
        conferences: ""
      }
    },

    {
      name: "Ms. Monika",
      designation: "Assistant Professor",
      phone: "9541662453",
      qualification: "Bcom, Mcom,UGC NET qualified",
      department: "Commerce",
      workingSince: "1st August, 2025",
      image: "",
      academicAchievements: {
        booksPublished: "",
        researchPapers: "",
        conferences: ""
      }
    },

    {
      name: "Ms. Sunita",
      designation: "Assistant Professor",
      phone: "9896496999",
      qualification: "M.Sc. (Home Science)",
      department: "Home Science",
      workingSince: "20th September, 2023",
      image: "assets/img/faculty/teaching/Sunita.png",
      academicAchievements: {
        booksPublished: "",
        researchPapers: "3 papers published/presented",
        conferences: ""
      }
    },
    {
      name: "Ms. Ritu Bala",
      designation: "Assistant Professor",
      phone: "8570039501",
      qualification: "B.com., Mcom.",
      department: "Commerce and Management",
      workingSince: "8th August, 2025",
      image: "assets/img/faculty/teaching/ritu.jpeg",
      academicAchievements: {
        booksPublished: "",
        researchPapers: "",
        conferences: ""
      }
    },

    {
      name: "Ms. Jasveen",
      designation: "Assistant Professor",
      phone: "9350710174",
      qualification: "M.A History,NET Qualified",
      department: "History",
      workingSince: "8th August, 2025",
      image: "assets/img/faculty/teaching/jasveen.jpeg",
      academicAchievements: {
        booksPublished: "",
        researchPapers: "",
        conferences: ""
      }
    },

    {
      name: "Ms. Navjot Kaur",
      designation: "Assistant Professor",
      phone: "9501323277",
      qualification: "M.A English,NETJRF Qualified",
      department: "English",
      workingSince: "22nd December, 2025",
      image: "",
      academicAchievements: {
        booksPublished: "",
        researchPapers: "",
        conferences: ""
      }
    },

    // {
    //   name: "Ms. Bhavya",
    //   designation: "Assistant Professor",
    //   phone: "",
    //   qualification: "M.Sc (Physics), NET",
    //   department: "Physics",
    //   workingSince: "2016",
    //   image: "",
    //   academicAchievements: {
    //     booksPublished: "",
    //     researchPapers: "",
    //     conferences: ""
    //   }
    // },

    {
      name: "Ms. Ishu",
      designation: "Assistant Professor",
      phone: "8950260134",
      qualification: "B.Com., M.Com., B.Ed.",
      department: "Commerce and Management",
      workingSince: "17th October, 2023",
      image: "assets/img/faculty/teaching/ishu.jpg",
      academicAchievements: {
        booksPublished: "",
        researchPapers: "",
        conferences: ""
      }
    },
    {
      name: "Ms. Neelam Devi",
      designation: "Assistant Professor",
      phone: "",
      qualification: "MPED,NET Qualified",
      department: "Physical Education",
      workingSince: "2nd February, 2026",
      image: "",
      academicAchievements: {
        booksPublished: "",
        researchPapers: "",
        conferences: ""
      }
    },

    {
      name: "Ms. Renu Gusain",
      designation: "Assistant Professor",
      phone: "",
      qualification: "MPED,NET Qualified",
      department: "Physical Education",
      workingSince: "2nd February, 2026",
      image: "",
      academicAchievements: {
        booksPublished: "",
        researchPapers: "",
        conferences: ""
      }
    },

    {
      name: "Ms. Neha Rani",
      designation: "Assistant Professor",
      phone: "8958720806",
      qualification: "MPED,NET Qualified",
      department: "Physical Education",
      workingSince: "2nd February, 2026",
      image: "",
      academicAchievements: {
        booksPublished: "",
        researchPapers: "",
        conferences: ""
      }
    },

    {
      name: "Ms. Mamta Meena",
      designation: "Assistant Professor",
      phone: "",
      qualification: "MPED,NET Qualified",
      department: "Physical Education",
      workingSince: "2nd February, 2026",
      image: "",
      academicAchievements: {
        booksPublished: "",
        researchPapers: "",
        conferences: ""
      }
    },

    {
      name: "Ms. Heena",
      designation: "Assistant Professor",
      phone: "",
      qualification: "M.Sc. (Home Science)",
      department: "Home Science",
      workingSince: "",
      image: "assets/img/faculty/teaching/heena.jpeg",
      academicAchievements: {
        booksPublished: "",
        researchPapers: "",
        conferences: ""
      }
    },

    {
      name: "Ms. Pargati",
      designation: "Assistant Professor",
      phone: "",
      qualification: "BPED, MPED",
      department: "Physical Education",
      workingSince: "",
      image: "assets/img/faculty/teaching/pargati.jpeg",
      academicAchievements: {
        booksPublished: "",
        researchPapers: "",
        conferences: ""
      }
    },

    {
      name: "Ms. Shivranjani",
      designation: "Assistant Professor",
      phone: "",
      qualification: "M.A. (Music)",
      department: "Music",
      workingSince: "",
      image: "assets/img/faculty/teaching/shivranjani.jpeg",
      academicAchievements: {
        booksPublished: "",
        researchPapers: "",
        conferences: ""
      }
    }
  ];
  selectedStaff: FacultyMember | null = null;
  showModal = false;

  constructor() { }

  ngOnInit(): void {
  }

  getInitials(name: string): string {
    if (!name) return '';
    let cleanName = name.replace(/^(Dr\.|Ms\.|Mr\.|Mrs\.)\s+/i, '');
    let parts = cleanName.split(/\s+/).filter(p => p.length > 0);
    if (parts.length === 1) {
      return parts[0].substring(0, 2).toUpperCase();
    }
    return (parts[0][0] + (parts[1][0] || '')).toUpperCase();
  }

  openDetails(staff: FacultyMember) {
    this.selectedStaff = staff;
    this.showModal = true;
    document.body.style.overflow = 'hidden'; // prevent scroll
  }

  closeModal() {
    this.showModal = false;
    this.selectedStaff = null;
    document.body.style.overflow = 'auto';
  }
}
